/**
 * vendors.js — Vendor page filtering logic.
 *
 * Handles:
 *  - Gender filter tabs (Alle / Dame / Herre)
 *  - Letter nav filter (clicking a letter shows only that letter's group)
 *  - Real-time search filtering (resets letter filter while typing)
 *  - Letter nav dim state (letters with no visible brands are dimmed)
 */
(function () {
  // Run after DOM is ready. With defer, readyState is already interactive/complete,
  // so the else-branch fires immediately — no timing gap.
  function init() {
    const root = document.querySelector('vendor-page');
    if (!root) return;

    let activeFilter = 'alle';
    let activeLetter = 'alle';
    let searchTerm   = '';

    const tabs       = Array.from(root.querySelectorAll('[data-filter]'));
    const searchInput = root.querySelector('[data-vendor-search]');
    const letterTabs  = Array.from(root.querySelectorAll('[data-letter-tab]'));
    const groups      = Array.from(root.querySelectorAll('[data-letter-section]'));
    const links       = Array.from(root.querySelectorAll('[data-vendor]'));

    // ── Gender tabs ──────────────────────────────────────────
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeFilter = tab.dataset.filter;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('vendors-filter__tab--active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    // ── Search ───────────────────────────────────────────────
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchTerm = searchInput.value.toLowerCase().trim();
        if (searchTerm !== '') {
          activeLetter = 'alle';
        }
        applyFilters();
      });
    }

    // ── Letter nav ───────────────────────────────────────────
    letterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('vendors-letter-nav__tab--dimmed')) return;

        activeLetter = tab.dataset.letterTab;

        if (searchInput && searchTerm !== '') {
          searchInput.value = '';
          searchTerm = '';
        }

        applyFilters();
      });
    });

    // ── Combined filter logic ────────────────────────────────
    function hide(el)  { el.style.display = 'none'; }
    function show(el)  { el.style.display = '';     }
    function visible(el) { return el.style.display !== 'none'; }

    function applyFilters() {
      // 1. Show/hide individual brand links (gender + search)
      links.forEach(function (link) {
        var genders     = (link.dataset.gender || '').split(' ');
        var genderMatch = activeFilter === 'alle' || genders.indexOf(activeFilter) !== -1;
        var searchMatch = searchTerm === '' || link.dataset.vendor.indexOf(searchTerm) !== -1;
        (genderMatch && searchMatch) ? show(link) : hide(link);
      });

      // 2. Show/hide letter groups; update dim state on letter tabs
      groups.forEach(function (group) {
        var hasVisible  = Array.from(group.querySelectorAll('[data-vendor]')).some(visible);
        var letter      = group.dataset.letterSection;
        var letterMatch = activeLetter === 'alle' || letter === activeLetter;

        (!hasVisible || !letterMatch) ? hide(group) : show(group);

        var tab = null;
        for (var i = 0; i < letterTabs.length; i++) {
          if (letterTabs[i].dataset.letterTab === letter) { tab = letterTabs[i]; break; }
        }
        if (tab) {
          tab.classList.toggle('vendors-letter-nav__tab--dimmed', !hasVisible);
          tab.setAttribute('aria-disabled', hasVisible ? 'false' : 'true');
        }
      });

      // 3. Highlight active letter tab
      letterTabs.forEach(function (t) {
        t.classList.toggle('vendors-letter-nav__tab--current', t.dataset.letterTab === activeLetter);
      });
    }

    // Run initial filter pass (dims tabs for empty letters, sets all-active state)
    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

// Keep the custom element definition so Shopify's theme editor can find the element
// (does nothing functional — all logic is handled by the IIFE above)
if (typeof customElements !== 'undefined' && !customElements.get('vendor-page')) {
  customElements.define('vendor-page', class extends HTMLElement {});
}
